// extracted by mini-css-extract-plugin
module.exports = {"root":"drawer-body_root__dpSb7","disablePadding":"drawer-body_disablePadding__HS0ib"};